import { ItemType, NavigationItem } from '../../../../models/Navigation';

export const marketStatsDropdownOptions: NavigationItem[] = [
  {
    type: ItemType.NAVLINK,
    text: 'Bonds',
    to: '/market-stats/bonds',
  },
  {
    type: ItemType.NAVLINK,
    text: 'Loans',
    to: '/market-stats/loans',
  },
  {
    type: ItemType.NAVLINK,
    text: 'Special Situations',
    to: '/market-stats/special-situation',
  },
  {
    type: ItemType.NAVLINK,
    text: 'Structured Finance',
    to: '/market-stats/structured-finance',
  },
];
